<div class="busqueda-wrap">
  <div id="titulo">
    <h2>Buscador de Talleres GT</h2>
    <h2 id="btnCerrar" mat-flat-button (click)="onClose()">X</h2>
  </div>
  <div id="tablaContainer">
    <table mat-table [dataSource]="dataSource" class="tabla-art">
      <ng-container matColumnDef="seleccion">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="col-seleccion" (click)="seleccionarTaller(element, $event)">
          <img
            class="icono-seleccion"
            src="assets/icons/location.svg"
            alt="Seleccionar taller"
            width="22"
            height="22"
          >
        </td>
      </ng-container>

      <ng-container *ngFor="let column of dataColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef>{{ columnLabels[column] }}</th>
        <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="fila-seleccionable"
        (click)="seleccionarTaller(row)"
        (dblclick)="seleccionarTaller(row)"
      ></tr>
    </table>
  </div>
</div>
